import { useLayoutEffect, useRef, useState } from "react";

export const useStepWidth = (stepLength: number) => {
  const stepperRef = useRef<HTMLDivElement>(null);
  const [stepWidth, setStepWidth] = useState("");

  useLayoutEffect(() => {
    const calculateStepContainerWidth = () => {
      if (stepperRef.current) {
        setStepWidth(`${stepperRef.current?.offsetWidth / stepLength}px`);
      }
    };

    calculateStepContainerWidth();

    window.addEventListener("resize", calculateStepContainerWidth);

    return () => {
      window.removeEventListener("resize", calculateStepContainerWidth);
    };
  }, [stepLength]);

  return {
    stepperRef,
    stepWidth,
  };
};
